(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function () {
    'use strict';
    if (window.__mystoFooterNewsletterModal) return;
    window.__mystoFooterNewsletterModal = true;

    var docEl = document.documentElement;

    function visibleModal() {
      return document.querySelector('[data-mysto-newsletter-success-modal]:not([hidden])');
    }

    function isFooterNewsletterResult() {
      return window.location.hash && window.location.hash.indexOf('FooterNewsletterForm') !== -1;
    }

    function suppressDefaultSuccess() {
      if (!docEl.classList.contains('mysto-newsletter-success-open')) return;
      var newsletters = document.querySelectorAll('coretex-newsletter');
      for (var i = 0; i < newsletters.length; i++) {
        var n = newsletters[i];
        if (!n.querySelector('[data-form-status]')) continue;
        n.setAttribute('data-mysto-footer-success-hidden', 'true');
        n.style.setProperty('display', 'none', 'important');
        n.style.setProperty('visibility', 'hidden', 'important');
        n.style.setProperty('pointer-events', 'none', 'important');
        var dialog = n.querySelector('dialog');
        if (dialog && dialog.open && typeof dialog.close === 'function') {
          try { dialog.close(); } catch (e) {}
        }
      }
    }

    function closeModal(modal) {
      if (!modal) return;
      modal.hidden = true;
      docEl.classList.remove('mysto-newsletter-success-open');
      var form = document.querySelector('.mysto-footer-newsletter-form');
      if (form && typeof form.scrollIntoView === 'function') {
        try { form.scrollIntoView({ block: 'center' }); }
        catch (e) { form.scrollIntoView(); }
      }
    }

    function init() {
      var modal = visibleModal();
      if (!modal) return;
      if (!isFooterNewsletterResult()) {
        modal.hidden = true;
        return;
      }
      docEl.classList.add('mysto-newsletter-success-open');
      suppressDefaultSuccess();
      [0, 300, 1200, 2600].forEach(function (t) {
        window.setTimeout(suppressDefaultSuccess, t);
      });
      document.addEventListener('click', function (e) {
        var trigger = e.target.closest && e.target.closest('[data-mysto-newsletter-success-close]');
        if (!trigger) return;
        var m = trigger.closest('[data-mysto-newsletter-success-modal]');
        if (!m) return;
        e.preventDefault();
        closeModal(m);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        closeModal(visibleModal());
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
